import React from "react";

const SmsMarketing = () => {
  return (
    <>
      <div className="info">
        <p>
          A través de la utilización de mensajes de texto, ITC-SMS, le permite
          enviar información personalizada de los productos y servicios que
          ofrece su empresa, en tiempo real, a diferentes públicos consumidores.
          ¿Cómo funciona? La tecnología desarrollada le permite realizar
          diversas acciones de marketing y publicidad, de envío e interactivas,
          que se adaptan a las necesidades de cada Empresa. El software, tiene
          la capacidad de enviar más de 1.500 mensajes de texto por hora.
          Asimismo, permite programar los horarios de cada campaña, a fin de que
          los SMS lleguen a sus clientes en los días y horarios que usted elija.
        </p>
      </div>
      <div className="table">
        <div>
          {" "}
          <h4>Usos de los SMS</h4>
          <ul>
            <li> Venta de Productos.</li>
            <li>Confirmación de Turnos. </li>
            <li>Información a Clientes.</li>
            <li> Ofertas.</li>
            <li>Publicidades.</li>
            <li>Logística.</li>
          </ul>
        </div>
        <div>
          <h4>Beneficios de los SMS</h4>
          <ul>
            <li>No necesita instalar Ningún Software.</li>
            <li>Un mensaje SMS es Directo y Discreto.</li>
            <li>Un mensaje SMS es Barato.</li>
            <li>Todos los SMS cuestan lo mismo a Cualquier parte del País.</li>
            <li>Puede realizar Campañas tanto de Marketing y Comunicación.</li>
            <li>
              El SMS llega al Dueño del Celular Directamente sin tener que pasar
              filtros.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default SmsMarketing;
